module.exports = __webpack_public_path__ + "img/home.3a110f1e.jpg";